module.exports = __webpack_public_path__ + "static/media/header_title.70bbb903.png";